import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType, GaTrackingEventName } from '../../constants';
import { EventWithLabel } from '~shared/modules/seo/constants';

export class GATrackingCustomLinkedGridClickEvent implements GATrackingEvent {
  constructor(private payload: EventWithLabel) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.CustomLinkedGrid;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.CustomLinkedGrid,
      label: this.payload.label,
    };
  }
}
